export const QUESTION_TYPES = {
  SINGLE_SELECT: 'singleSelect',
  MULTIPLE_SELECT: 'multipleSelect',
  FILL_IN_BLANK: 'fillInBlank',
} as const;

export type QuestionType = (typeof QUESTION_TYPES)[keyof typeof QUESTION_TYPES];

export const ALL_QUESTION_TYPES: QuestionType[] = [
  QUESTION_TYPES.SINGLE_SELECT,
  QUESTION_TYPES.MULTIPLE_SELECT,
  QUESTION_TYPES.FILL_IN_BLANK,
];
